import { Rectangle } from '../../math/geometry/rectangle';
import { CurveFactory } from '../../math/geometry';
export class RRect extends Rectangle {
    constructor(t) {
        super(t);
        this.radX = t.radX;
        this.radY = t.radY;
        this.roundedRect_ = CurveFactory.mkRectangleWithRoundedCorners(this.width, this.height, t.radX, t.radY, this.center);
    }
    onUpdated() {
        if (!this.isEmpty) {
            this.roundedRect_ = CurveFactory.mkRectangleWithRoundedCorners(this.width, this.height, this.radX, this.radY, this.center);
        }
    }
    isOk() {
        if (this.isEmpty()) {
            return true;
        }
        return this.roundedRect_.boundingBox.equalEps(this);
    }
    setRect(value) {
        this.left = value.left;
        this.right = value.right;
        this.top = value.top;
        this.bottom = value.bottom;
        if (!this.isEmpty()) {
            this.roundedRect_ = CurveFactory.mkRectangleWithRoundedCorners(value.width, value.height, this.radX, this.radY, this.center);
        }
    }
}
//# sourceMappingURL=RRect.js.map